module.exports = __webpack_public_path__ + "static/home-illustration-2-f848cbcf1bae8e75dfd8733d413e5773.svg";